import React from 'react';
import PropTypes from 'prop-types';
import Image from '../Image';
import Logo from '../Logo';
import Text from '../Text';

import * as styles from './Footer.module.less';

import * as footerLinks from './footerLinks';

import trustPilotLogo from './trust-pilot-logo.svg';
import accreditBusinessLogo from './accredited-business-logo.webp';

const Footer = ({ topicLinks, bottomLinks, extended }) => {
  const isEmail = link => /^mailto:/.test(link.url);
  return (
    <footer className={extended && styles.extended}>
      <div className={styles.top}>
        <div className={styles.topContainer}>
          <div className={styles.main}>
            <div className={styles.columns}>
              {topicLinks.map(topic => (
                <div key={topic.header} className={styles.column}>
                  <Text className={styles.header}>{topic.header}</Text>
                  <ul className={styles.list}>
                    {topic.links.map(link => (
                      <li key={`${link.text}-${link.url}`}>
                        <a
                          href={link.url}
                          className={isEmail(link) ? styles.email : styles.link}
                        >
                          {link.text}
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
            <div className={styles.info}>
              <div className={styles.logo}>
                <Logo />
              </div>
              <div className={styles.address}>
                {`© ${new Date().getFullYear()} NerdWallet Inc.`}
                <br />
                55 Hawthorne Street,
                <br />
                10th Floor, Suite 1,
                <br />
                San Francisco, California 94105
              </div>
              <div className={styles.logos}>
                <Image
                  src={trustPilotLogo}
                  alt="Trustpilot Logo"
                  lazyload
                  width="80"
                  height="40"
                />
                <a
                  href="https://www.bbb.org/new-york-city/business-reviews/loans/fundera-in-new-york-ny-162542/#bbbonlineclick"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Image
                    src={accreditBusinessLogo}
                    alt="Fundera BBB Business Review"
                    lazyload
                    width="80"
                    height="30"
                  />
                </a>
              </div>
            </div>
          </div>
          <div className={styles.disclaimer}>
            <Text>Fundera, Inc. NMLS ID# 1240038 </Text>
            <a
              href="https://nmlsconsumeraccess.org"
              target="_blank"
              rel="noopener noreferrer"
            >
              NMLS Consumer Access 
            </a>
            <br />
            <strong>California: </strong>
            <Text>
              {' '}
              California Finance Lender loans arranged pursuant to the
              Department of Financial Protection and Innovation Finance Lenders
              License #603L288
            </Text>
          </div>
        </div>
      </div>
      <div className={styles.bottom}>
        <div className={styles.bottomContainer}>
          <ul className={styles.bottomList}>
            {bottomLinks.map((link, i) => {
              if (link.type === 'spacer') {
                return <li key={`spacer-${i}`} className={styles.spacer} />;
              }

              return (
                <li key={link.text}>
                  {link.url ? (
                    <a href={link.url}>{link.text}</a>
                  ) : (
                    <Text>{link.text}</Text>
                  )}
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </footer>
  );
};

Footer.propTypes = {
  extended: PropTypes.bool,
  topicLinks: PropTypes.arrayOf(
    PropTypes.shape({
      header: PropTypes.string,
      links: PropTypes.arrayOf(
        PropTypes.shape({
          text: PropTypes.string.isRequired,
          url: PropTypes.string,
        })
      ),
    })
  ),
  bottomLinks: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string.isRequired,
      url: PropTypes.string,
    })
  ),
};

Footer.defaultProps = {
  extended: false,
  topicLinks: footerLinks.topicLinks,
  bottomLinks: footerLinks.bottomLinks,
};

export default Footer;
